import React from "react";

const ComponentLoader = ({ size = 60, color = "#ff0000", text = "Loading..." }) => {
    const borderWidth = size / 10;

    const spinnerStyle = {
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        border: `${borderWidth}px solid rgba(0, 0, 0, 0.1)`,
        borderTop: `${borderWidth}px solid ${color}`,
        animation: "spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite",
        marginBottom: "20px",
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "30vh",
                color: "#333",
                textAlign: "center",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            }}
        >
            <div style={spinnerStyle}></div>
            <h2 style={{ fontWeight: 600, fontSize: "1.2rem", color: color }}>{text}</h2>

            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
        </div>
    );
}
export default ComponentLoader;